export type ClassValue = string | number | false | null | undefined;

/** Join truthy class names with a space. Keeps component class composition
 *  readable without pulling in a dependency. Note: it does NOT de-dupe
 *  conflicting Tailwind classes — author variants so they don't collide
 *  (e.g. set border color in exactly one place). */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
